import { forwardRef } from 'react';

import { IconProps } from '.';

export const ListIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M5.99999 6.75C5.99999 7.37408 5.49407 7.88 4.86999 7.88C4.24591 7.88 3.73999 7.37408 3.73999 6.75C3.73999 6.12591 4.24591 5.62 4.86999 5.62C5.49407 5.62 5.99999 6.12591 5.99999 6.75Z"
        fill="currentColor"
      />
      <path
        d="M8.24999 15H16.5C16.6989 15 16.8897 14.921 17.0303 14.7803C17.171 14.6397 17.25 14.4489 17.25 14.25C17.25 14.0511 17.171 13.8603 17.0303 13.7197C16.8897 13.579 16.6989 13.5 16.5 13.5H8.24999C8.05108 13.5 7.86031 13.579 7.71966 13.7197C7.57901 13.8603 7.49999 14.0511 7.49999 14.25C7.49999 14.4489 7.57901 14.6397 7.71966 14.7803C7.86031 14.921 8.05108 15 8.24999 15Z"
        fill="currentColor"
      />
      <path
        d="M16.5 11.25H8.24999C8.05108 11.25 7.86031 11.171 7.71966 11.0303C7.57901 10.8897 7.49999 10.6989 7.49999 10.5C7.49999 10.3011 7.57901 10.1103 7.71966 9.96967C7.86031 9.82902 8.05108 9.75 8.24999 9.75H16.5C16.6989 9.75 16.8897 9.82902 17.0303 9.96967C17.171 10.1103 17.25 10.3011 17.25 10.5C17.25 10.6989 17.171 10.8897 17.0303 11.0303C16.8897 11.171 16.6989 11.25 16.5 11.25Z"
        fill="currentColor"
      />
      <path
        d="M8.24999 7.5H16.5C16.6989 7.5 16.8897 7.42098 17.0303 7.28033C17.171 7.13968 17.25 6.94891 17.25 6.75C17.25 6.55109 17.171 6.36032 17.0303 6.21967C16.8897 6.07902 16.6989 6 16.5 6H8.24999C8.05108 6 7.86031 6.07902 7.71966 6.21967C7.57901 6.36032 7.49999 6.55109 7.49999 6.75C7.49999 6.94891 7.57901 7.13968 7.71966 7.28033C7.86031 7.42098 8.05108 7.5 8.24999 7.5Z"
        fill="currentColor"
      />
      <path
        d="M4.86999 11.63C5.49407 11.63 5.99999 11.1241 5.99999 10.5C5.99999 9.87591 5.49407 9.37 4.86999 9.37C4.24591 9.37 3.73999 9.87591 3.73999 10.5C3.73999 11.1241 4.24591 11.63 4.86999 11.63Z"
        fill="currentColor"
      />
      <path
        d="M5.99999 14.25C5.99999 14.8741 5.49407 15.38 4.86999 15.38C4.24591 15.38 3.73999 14.8741 3.73999 14.25C3.73999 13.6259 4.24591 13.12 4.86999 13.12C5.49407 13.12 5.99999 13.6259 5.99999 14.25Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default ListIcon;
